import Divider from "antd/es/divider";
import React from "react";
import styled from "styled-components";
import { Task } from "src/types/tasks";
import { useTasks } from "src/context/tasks";

interface TaskCartProps {
  selectedTasks: Task[];
}

export const TaskCart: React.FC<TaskCartProps> = ({ selectedTasks }) => {
  const { tipAmount } = useTasks();
  const getSubtotal = React.useCallback((): number => {
    return selectedTasks.reduce(
      (sum, task) => sum + task.current_price_cents / 100,
      0
    );
  }, [selectedTasks]);

  const getTax = React.useCallback((): number => {
    const subtotal = getSubtotal();
    return Math.round((subtotal * 8.875) / 100);
  }, [getSubtotal]);

  const getTotal = React.useCallback((): number => {
    return getSubtotal() + getTax();
  }, [getSubtotal, getTax]);

  const subtotal = getSubtotal();
  const tax = getTax();
  const total = getTotal();

  return (
    <CartContainer>
      <p className="flex justify-content-between">
        <span className="blue">Subtotal:</span>
        <span className="blue">${subtotal.toFixed(2)}</span>
      </p>

      <p className="flex justify-content-between">
        <span className="blue">Tax:</span>
        <span className="blue">${tax.toFixed(2)}</span>
      </p>

      {tipAmount > 0 && (
        <p className="flex justify-content-between">
          <span className="blue">Tip:</span>
          <span className="blue">${tipAmount.toFixed(2)}</span>
        </p>
      )}

      <Divider style={{ color: "#B1DCE5" }} />

      <p className="flex justify-content-between">
        <span className="blue">Total:</span>
        <span className="blue">${(total + tipAmount).toFixed(2)}</span>
      </p>
    </CartContainer>
  );
};

const CartContainer = styled.div`
  width: 100%;
  background-color: #dff9ff;
  padding: 25px;
  color: #000;
  flex-shrink: 0; /* Prevent cart from shrinking */
  height: auto;

  .blue {
    font-weight: 600;
    color: #323593;
  }

  @media screen and (max-width: 991px) {
    padding: 25px;
  }
`;
